import SymbologyFilterEvaluator from "aims-map/lib/layers/dynamic/symbology-filter-evaluator";

/**
 * Extends AimsMap.DynamicLayerFeatureStyler for this specific solution.
 */

const olCircleStyle = (global.ol ? global.ol.style.Circle : require('ol/style/circle'));
const olFillStyle = (global.ol ? global.ol.style.Fill : require('ol/style/fill'));
const olStrokeStyle = (global.ol ? global.ol.style.Stroke : require('ol/style/stroke'));
const olStyle = (global.ol ? global.ol.style.Style : require('ol/style/style'));

import { AbstractDynamicLayerFeatureStyler } from 'aims-map';

export default class DynamicLayerFeatureStylerImpl extends AbstractDynamicLayerFeatureStyler {

  /**
   * Constructor to capture the reference to the VariablesModel which is used to determine which
   * field to use to determine the style to return in {@link #identifyStyle()}.
   */
  constructor(variablesModel) {

    super();

    // Cache the reference(s).
    this._variablesModel = variablesModel;

    // Provide a local cache of the current Variable.
    this._variablesModel.on(this._variablesModel.ON_SELECTION_EVENT, (variable) => {
      this._selectedVariable = variable;
    });

    // Pre-populate the internal cache.
    this._internalCache = {};

  }

  /**
   * Build the cache for all styles defined in the Variables.
   */
  buildCache() {

    // Clear the internal cache.
    this._internalCache = {};

    // Loop through each variable.
    this._variablesModel.getItems().forEach(function (variable) {
      this._internalCache[variable.id] = [];

      variable.groupings.forEach(function (_grouping) {

        // A style definition has a Filter and a Symbol.
        const filter = _grouping.filter;
        const symbol = _grouping.renderings.map.symbol;

        // Build an OpenLayers style and cache for future use.
        const fill = new olFillStyle({
          color: symbol.fill.color
        });
        const stroke = (
          symbol.stroke ?
            new olStrokeStyle({
              color: symbol.stroke.color,
              width: symbol.stroke.width
            }) :
            undefined
        );
        let featureImage = undefined;
        switch (symbol.type) {
          case 'circle':
          default:
            featureImage = new olCircleStyle({
              radius: symbol.size,
              fill,
              stroke: stroke
            });
            break;
        }
        const nonSelectableStyle = new olStyle({ image: featureImage });
        const selectableStyle = nonSelectableStyle.clone();
        selectableStyle.getImage().getStroke().setWidth(1);
        selectableStyle.getImage().getStroke().setColor('#000000B0');

        // Cache the style.
        this._internalCache[variable.id].push({
          filter,
          nonSelectableStyle,
          selectableStyle
        });

      }, this);

    }, this);

  }

  /**
   * Override the default implementation to modify the style depending on the items attributes
   */
  identifyStyle(siteDetails) {
    if (this._selectedVariable && siteDetails) {
      const _fieldName = this._selectedVariable.fieldName;
      const _groupingsCache = this._internalCache[this._selectedVariable.id];

      // Find the definition that matches based on the filter.
      const cachedItem = _groupingsCache.find(function(_cachedItem) {
        const isTrue = SymbologyFilterEvaluator(
          _cachedItem.filter,
          _fieldName,
          siteDetails.data
        );
        return isTrue;
      }, this);

      // Was a cached item found?
      if (cachedItem) {

        // Cached item found.
        if (siteDetails.isSelectable) {
          return cachedItem.selectableStyle;
        } else {
          return cachedItem.nonSelectableStyle;
        }

      } else {

        // Cached item not found.
        return undefined;

      }

    }

    // No style found.
    return undefined;

  }

}



// WEBPACK FOOTER //
// ./src/app/map/dynamic-layer-feature-styler-impl.js